export default {"src":"/nachrichten/_next/static/media/ThemeSystemIcon.32b6e32c.svg","height":124,"width":70,"blurWidth":0,"blurHeight":0};